import { SaveSummarySectionVariant } from './PendingChangesSaveSummary.constants';

export const summaryWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
};

export const getSectionStyles = (variant = SaveSummarySectionVariant.DEFAULT) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  padding: '10px 12px',
  borderRadius: '8px',
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  backgroundColor: ({ palette }) =>
    variant === SaveSummarySectionVariant.WARNING
      ? palette.background.tableHighlight
      : palette.background.secondary,
});

export const listStyles = {
  margin: 0,
  paddingLeft: '18px',
};

export const recalculatedToggleStyles = {
  alignSelf: 'flex-start',
  gap: '4px',
  padding: '2px 4px',
  minWidth: 0,
  color: ({ palette }) => palette.text.link,
  textTransform: 'none',
};

export const authorLineStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
};

export const getDotStyles = color => ({
  width: '8px',
  height: '8px',
  borderRadius: '50%',
  flexShrink: 0,
  backgroundColor: ({ palette }) => color || palette.border.input,
});

export const automaticFeeTagStyles = {
  display: 'inline-flex',
  verticalAlign: 'middle',
  ml: '6px',
};
